import useTranslation from "next-translate/useTranslation"
import InfiniteScroll from "react-infinite-scroll-component"
import { Col, Row } from "reactstrap"

import { IProject } from "@api/schema"
import { SCROLLABLE_MAIN_PAGE } from "@components/BaseLayout"
import ProjectCard from "@components/marketplace/projects/ProjectCard"

import MarketInfoCard, { MarketInfoCardType } from "../MarketInfoCard"

interface IProps {
  loadNext: () => void
  projects: IProject[]
  hasNext: boolean
  infoCard?: MarketInfoCardType
}

/**
 * Scroller for projects for the MarketPlace
 */
const ProjectScroller: React.FC<IProps> = (props: IProps) => {
  const { projects, hasNext, loadNext, infoCard } = props
  const { t } = useTranslation("common")

  const wrappedProjects = projects.map((project) => (
    <ProjectCard
      key={"project_" + project.id.toString()}
      project={project}
    />
  ))

  /*  const empty = <Col className="p-0 col" md={12} lg={6} xl={8} key="empty"><EmptyProjectCard/></Col>

  if (projects.length <= 3) {
    wrappedProjects.push(empty)
  } else {
    wrappedProjects.splice(3, 0, empty)
  }*/

  return (
    <InfiniteScroll
      dataLength={projects.length + 1}
      next={loadNext}
      hasMore={hasNext}
      loader={null}
      scrollableTarget={SCROLLABLE_MAIN_PAGE}
      // @todo: transform into css class, @linda
      style={{ overflow: "hidden", overflowY: "auto" }}
    >
      {projects.length === 0 &&
        <Row>
          <Col>{t("page.projects.index.noProjects")}</Col>
        </Row>
      }
      <Row className="card-grid-layout">
        {infoCard && <MarketInfoCard
          showPicture={projects?.length === 0}
          type={infoCard}
        />}
        {wrappedProjects}</Row>
    </InfiniteScroll>
  )
}

export default ProjectScroller
